export const routes = [
  {
    path: "/ia-coleta-evidencias",
    component: () =>
      import(
        /* webpackChunkName: "ia-coleta-evidencias" */ "./components/Layout.vue"
      ),
    children: [
      {
        path: "",
        redirect: "/ia-coleta-evidencias/painel",
      },
      {
        path: "painel",
        name: "ia-coleta-evidencias.painel",
        component: () =>
          import(
            /* webpackChunkName: "ia-coleta-evidencias" */ "./components/Painel.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "regras",
        name: "ia-coleta-evidencias.regras",
        component: () =>
          import(
            /* webpackChunkName: "ia-coleta-evidencias" */ "./components/Regras.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
];
